import {
  SET_ALL_EXPENSES,
  SET_EXPENSE_TYPE,
  RESET_SPECIFIC_CATEGORIES,
  RESET_SPECIFIC_SUB_CATEGORIES,
  RESET_SUB_CATEGORIES,
  RESET_CATEGORIES,
  SET_SPECIFIC_CATEGORIES,
  SET_SPECIFIC_SUB_CATEGORIES,
  SET_SUB_CATEGORIES,
} from "../Types/ExpenseTypes";

const initialState = {
  allExpenses: [],
  expenseTypes:[],
  specificCategory: null,
  subCategories: [],
  specificSubCategory: null,
};

const ExpenseReducer = (state = initialState, action) => {
  if (action.type === SET_ALL_EXPENSES) {
    return { ...state, allExpenses: action.payLoad };
  } else if (action.type === RESET_CATEGORIES) {
    return { ...state, categories: [] };
  } else if (action.type === SET_EXPENSE_TYPE) {
    return { ...state, expenseTypes: action.payLoad };
  } else if (action.type === RESET_SPECIFIC_CATEGORIES) {
    return { ...state, specificCategory: null };
  } else if (action.type === SET_SUB_CATEGORIES) {
    return { ...state, subCategories: action.payLoad };
  } else if (action.type === RESET_SUB_CATEGORIES) {
    return { ...state, subCategories: [] };
  } else if (action.type === SET_SPECIFIC_SUB_CATEGORIES) {
    return { ...state, specificSubCategory: action.payLoad };
  } else if (action.type === RESET_SPECIFIC_SUB_CATEGORIES) {
    return { ...state, specificSubCategory: null };
  } else {
    return state;
  }
};

export default ExpenseReducer;
